<app-auth-layout>
  <div class="auth-form-content">
    @if (isAuthenticating) {
      <div class="auth-authenticating">
        <vb-loading-spinner size="lg" color="primary" ariaLabel="Signing you in" />
        <p class="auth-authenticating-text">Signing you in&hellip;</p>
      </div>
    } @else {
    <div class="auth-form-header">
      <div class="auth-badge" title="Your connection is encrypted and your credentials are securely protected">
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 1C8.676 1 6 3.676 6 7v2H4a2 2 0 00-2 2v10a2 2 0 002 2h16a2 2 0 002-2V11a2 2 0 00-2-2h-2V7c0-3.324-2.676-6-6-6zm0 2c2.276 0 4 1.724 4 4v2H8V7c0-2.276 1.724-4 4-4zm0 10c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"/>
        </svg>
        Secure Login
      </div>
      <h2 class="auth-title">Sign in to your account</h2>
      <p class="auth-subtitle">Access the VB Portal to manage your wireless infrastructure all in one place.</p>
    </div>

    @if (errorMessage) {
      <vb-alert type="error" variant="soft" [showIcon]="true" [message]="errorMessage" class="block mb-4" />
    }

    <form (ngSubmit)="loginDirect()">
      <div class="auth-field">
        <vb-input
          id="email"
          name="email"
          type="email"
          label="Email Address"
          placeholder="name@company.com"
          [required]="true"
          [disabled]="isLoading"
          [(ngModel)]="email"
        />
      </div>

      <div class="auth-field">
        <vb-input
          id="password"
          name="password"
          type="password"
          label="Password"
          placeholder="Enter your password"
          [required]="true"
          [disabled]="isLoading"
          [(ngModel)]="password"
        />
      </div>

      <div class="auth-options">
        <vb-checkbox
          name="isRememberMe"
          label="Remember me"
          [disabled]="isLoading"
          [(ngModel)]="isRememberMe"
        />
        <a routerLink="/forgot-password" class="auth-forgot-link">Forgot password?</a>
      </div>

      <vb-button
        type="submit"
        variant="primary"
        size="md"
        [fullWidth]="true"
        [loading]="isLoading"
        [disabled]="isLoading">
        @if (isLoading) {
          Signing in...
        } @else {
          Sign In
        }
      </vb-button>
    </form>

    <div class="auth-divider">
      <span class="auth-divider-line"></span>
      <span class="auth-divider-text">Or continue with</span>
      <span class="auth-divider-line"></span>
    </div>

    <div class="auth-social-login">
      <vb-button social="apple" type="button" [disabled]="isLoading" (click)="loginWithSocial('apple')" />
      <vb-button social="google" type="button" [disabled]="isLoading" (click)="loginWithSocial('google-oauth2')" />
      <vb-button social="linkedin" type="button" [disabled]="isLoading" (click)="loginWithSocial('linkedin')" />
      <vb-button social="microsoft" type="button" [disabled]="isLoading" (click)="loginWithSocial('Online-Colo-AD')" />
    </div>

    <p class="auth-switch-link">
      Don't have an account? <a routerLink="/signup">Create an account</a>
    </p>

    <div class="auth-footer">
      <div class="auth-footer-links">
        <a routerLink="/terms-of-use">Terms of Use</a>
        <a routerLink="/privacy-policy">Privacy Policy</a>
        <a routerLink="/accessibility">Accessibility</a>
      </div>
      <p class="auth-footer-copyright">&copy; {{ currentYear }} Vertical Bridge REIT, LLC. All rights reserved.</p>
    </div>
    }
  </div>
</app-auth-layout>
